import moment from 'moment';

import { ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';

import type { ApiFilters, Filters, FilterProps } from './types';

export function isFilterEnabled(props: Record<string, FilterProps>, key: string): boolean {
  return props[key]?.enabled !== false;
}

export function getDefaults(
  { dateRangeEnabled = true, tbdEnabled = true, assigneeId = null }:
  { dateRangeEnabled?: boolean, tbdEnabled?: boolean, assigneeId?: number | null }
) : Filters {
  return {
    assigneeId: assigneeId,
    completed: false,
    dealUserId: null,
    fromDate: dateRangeEnabled ? moment().startOf('month').format(ISO_DATE_FORMAT) : null,
    officeId: null,
    open: false,
    overdue: false,
    parentType: null,
    query: '',
    tbd: tbdEnabled ? false : null,
    allTasks: null,
    toDate: dateRangeEnabled ? moment().endOf('month').format(ISO_DATE_FORMAT) : null,
  };
}

export function serializeFilters(filters: Filters): ApiFilters {
  const statuses: string[] = [];

  if (filters.completed) {
    statuses.push('completed');
  }

  if (filters.open) {
    statuses.push('open');
  }

  if (filters.overdue && !filters.tbd) {
    statuses.push('overdue');
  }

  const apiFilters: ApiFilters = {
    assigneeId: filters.assigneeId,
    dealUserId: filters.dealUserId,
    fromDate: filters.fromDate,
    officeId: filters.officeId,
    parentTypeFilter: filters.parentType,
    query: filters.query,
    statuses,
    tbd: filters.tbd,
    allTasks: filters.allTasks,
    toDate: filters.toDate,
  };

  return apiFilters;
}
